/**
 * Get a list of social media identifiers.
 *
 * The list comes from a comma separated cms item values.
 * Whitespace is trimmed. The list may be empty.
 *
 * @param {function} i18n - to retrieve cms values.
 * @returns {Array} a string array of social media identifiers,
 *          or null if there are none.
 */
export function getIdentifiers(
  i18n: (key: string, count?: number) => string
): string[] | null {
  const identifiers = i18n('social-media.buttons').trim();

  if (identifiers) {
    return identifiers
      .split(',')
      .map((identifier: string) => identifier.trim());
  }
  return null;
}
